import dayjs, { Dayjs } from "dayjs";

export interface ILookupItemModel {
  id?: number;
  name?: string;
  system?: boolean | undefined;
  deleted?: boolean | undefined;
}

export interface ILookupItemSimpleModel {
  id?: number;
  name?: string;
}
export interface IAddressModel {
  formattedAddress?: string | null;
  street?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  county?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  schoolDistrict?: string | null;
  country?: string | null;
  subpremise?: string;
}
export interface ITransactionFormData {
  id?: number | null | undefined;
  yearId: number | null;

  /** TransactionStatus: 1 = Lead, 2 = Active, 3 = Transaction */
  status?: number;
  leadReceivedDate?: Dayjs | null;
  transactionType: number | null;
  address: IAddressModel | null;
  latitude: number | null;
  longitude: number | null;
  date: Dayjs | null;
  price: number | null;
  source: number | null;
  // soiReferrer: ILookupItemModel[] | null;
  // agentReferrer: ILookupItemModel[] | null;

  clients: ILookupItemSimpleModel[] | null;
  notes: string | null;
  reason: number | null;
  area: ILookupItemModel | null;
  specialGroups: ILookupItemModel[] | null;
  specialTags: ILookupItemModel[] | null;
  coAgentMember: ILookupItemModel | null;
  coAgentMember2: ILookupItemModel | null;
  commissionPercentage: number | null;
  grossCommissionIncome: number | null;
  flatCommission: number | null;
  clientRebatePrice: number | null;
  clientRebateGCI: number | null;
  clientRebateFlatAmount: number | null;
  referralFeePaid: number | null;
  referralFeeReceived: number | null;
  coAgentSplit: number | null;
  coAgentSplit2: number | null;
  brokerageSplit: number | null;
  additionalCharges: number | null;
  incentivesPaid: number | null;
  netCommissionIncome: number | null;
  netIncome: number | null;
  netIncomePercentage: number | null;
  brkAnniversary: Dayjs | null;
  brkFlatFees: number | null;
  agentReferrers: ILookupItemSimpleModel[] | null;
  soiReferrers: ILookupItemSimpleModel[] | null;
  vendorReferrers?: ILookupItemSimpleModel[];
  vendors?: ILookupItemSimpleModel[];
  agentReferrered: ILookupItemSimpleModel[] | null;
  referralOutTypeId: number | null;
  runningSplitTotal?: number | undefined;
  runningAdditionalChargeTotal?: number | undefined;
}

export type Product = {
  id: number;
  title: string;
  price: number;
  description: string;
  image: string;
  features: string[];
  isSelected: boolean;
  onSelect: () => void;
};
export interface IRecurringModel {
  interval?: string | undefined;
  intervalCount?: number | undefined;
}
export interface IPriceInfoModel {
  priceId?: string;
  unitAmount?: number | undefined;
  currency?: string | undefined;
  recurring?: IRecurringModel | undefined;
  metadata?: { [key: string]: string };
}
export interface IProductModel {
  id?: string;
  name?: string;
  description?: string;
  features?: string[];
  priceId?: string;
  unitAmount?: number | undefined;
  currency?: string;
  interval?: string;
  intervalCount?: number | undefined;
  annualSavings?: number | undefined;
}
export interface IPlanModel {
  product?: IProductModel;
}

export interface IIntervalGroupModel {
  interval?: string;
  plans?: IPlanModel[];
}

export interface ISubscriptionModel {
  plan?: string;
  unitAmount?: number | undefined;
  created?: dayjs.Dayjs;
  currency?: string;
  daysUntilDue?: number | undefined;
  currentPeriodStart?: dayjs.Dayjs;
  currentPeriodEnd?: dayjs.Dayjs;
  startDate?: dayjs.Dayjs;
  status?: string;
  trialStart?: dayjs.Dayjs | undefined;
  trialEnd?: dayjs.Dayjs | undefined;
  description?: string;
  interval?: string | undefined;
}

export interface IActiveSubscriptionModel {
  activeSubscription?: ISubscriptionModel | undefined;
}

export interface ReportCategory {
  name: string;
  variables: {
    [key: string]: {
      count: number;
      totalPrice: number;
    };
  };
}

export interface ReportData {
  year: number;
  categories: ReportCategory[];
}

export interface IUserModel {
  userId?: string;
  email?: string;
  name?: string;
  subscriptionStatus?: string | undefined;
  stripeCustomerId?: string | undefined;
  subscriptionId?: string | undefined;
  plan?: string | undefined;
  isPro?: boolean;
  isAdmin?: boolean;
}

export interface IFinancialDtoModel {
  commissionPercentage?: number | undefined;
  flatCommissionAmount?: number | undefined;
  clientRebatePercentage?: number | undefined;
  clientRebateGciPercentage?: number | undefined;
  clientRebateFlatAmount?: number | undefined;
  referralFeePaidPercentage?: number | undefined;
  referralFeeReceivedPercentage?: number | undefined;
  coAgentSplitPaidPercentage?: number | undefined;
  coAgentSplit2PaidPercentage?: number | undefined;
  brokerageSplitPercentage?: number | undefined;
  brokerageAdditionalChargePercentage?: number | undefined;
  brokerageFlatFees?: number | undefined;
  incentivesAmount?: number | undefined;
  brokerageAnniversaryDate?: dayjs.Dayjs | undefined;
  date: Dayjs | null;
}
export interface ICreateTransactionModel {
  transactionId?: number | undefined;
  /** TransactionStatus: 1 = Lead, 2 = Active, 3 = Transaction */
  status?: number;
  leadReceivedDate?: dayjs.Dayjs | null;
  typeId?: number;
  date?: dayjs.Dayjs;
  sourceId?: number | undefined;
  reasonId?: number | undefined;
  address?: IAddressModel | undefined;
  price?: number;
  notes?: string | undefined;
  areaId?: number | undefined;
  coAgentId?: number | undefined;
  coAgent2Id?: number | undefined;
  insertedArea?: string | undefined;
  insertedCoAgent?: string | undefined;
  insertedCoAgent2?: string | undefined;
  selectedClients?: number[] | undefined;
  insertedClients?: string[] | undefined;
  selectedGroups?: number[] | undefined;
  insertedGroups?: string[] | undefined;
  selectedTags?: number[] | undefined;
  insertedTags?: string[] | undefined;
  selectedSoiReferrers?: number[] | undefined;
  insertedSoiReferrers?: string[] | undefined;
  selectedAgentReferrers?: number[] | undefined;
  insertedAgentReferrers?: string[] | undefined;
  selectedVendorReferrers?: number[] | undefined;
  insertedVendorReferrers?: string[] | undefined;
  selectedVendors?: number[] | undefined;
  insertedVendors?: string[] | undefined;
  selectedAgentReferredOut?: number[] | undefined;
  insertedAgentReferredOut?: string[] | undefined;
  // financial?: IFinancialDtoModel | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  forceDuplicate?: boolean | undefined;
  replace?: boolean;
}

export interface ITransactionTypeModel {
  id?: number;
  name?: string;
  isMonthlyRent?: boolean;
  showReferralOut?: boolean;
  /** Built-in type (not added by the user in Settings) */
  system?: boolean;
  deleted?: boolean | undefined;
  isSb?: boolean | undefined;
}
export interface ITransactionSourceModel {
  id?: number;
  name?: string;
  showSoiReferrer?: boolean;
  showAgentReferrer?: boolean;
  showVendorReferrer?: boolean;
  deleted?: boolean | undefined;
}
export interface IFormCategoryModel {
  id?: number;
  name?: string;
  internalName?: string;
}
export interface ICommonDataModel {
  categories?: IFormCategoryModel[];
}

// Area type preference enum to define how geographic areas are categorized
export enum AreaTypeEnum {
  State = 0,
  // ZipCode = 1,
  County = 2,
  Custom = 3,
}

export interface ICustomUserDataModel {
  coAgents?: ILookupItemModel[];
  specialGroups?: ILookupItemModel[];
  specialTags?: ILookupItemModel[];
  areas?: ILookupItemModel[];
  // clients?: ILookupItemModel[];
  // hiddenFields?: ILookupItemModel[];
  reasons?: ILookupItemModel[];
  // soiReferrers?: ILookupItemModel[];
  // agentReferrers?: ILookupItemModel[];
  sources?: ITransactionSourceModel[];
  transactionTypes?: ITransactionTypeModel[];
  referralOutTypes?: ILookupItemModel[];
  preferredAreaType?: AreaTypeEnum;
}
export interface IFinancialInfoModel {
  commissionPercentage?: number | undefined;
  flatCommissionAmount?: number | undefined;
  clientRebatePercentage?: number | undefined;
  clientRebateGciPercentage?: number | undefined;
  clientRebateFlatAmount?: number | undefined;
  referralFeePaidPercentage?: number | undefined;
  referralFeeReceivedPercentage?: number | undefined;
  coAgentSplitPaidPercentage?: number | undefined;
  coAgentSplit2PaidPercentage?: number | undefined;
  brokerageSplitPercentage?: number | undefined;
  brokerageAdditionalChargePercentage?: number | undefined;
  brokerageFlatFees?: number | undefined;
  incentivesAmount?: number | undefined;
  brokerageAnniversaryDate?: dayjs.Dayjs | undefined;
  brokerageSplitAmount?: number | undefined;
  brokerageAdditionalChargeAmount?: number | undefined;
  grossCommIncomeAmount?: number | undefined;
  clientRebateGciAmount?: number | undefined;
  clientRebateAmount?: number | undefined;
  referralFeePaidAmount?: number | undefined;
  referralFeeReceivedAmount?: number | undefined;
  coAgentSplitPaidAmount?: number | undefined;
  coAgentSplit2PaidAmount?: number | undefined;
  effectiveGciAmount?: number | undefined;
  brokerageTotalFees?: number | undefined;
  netCommissionIncome?: number | undefined;
  netIncome?: number | undefined;
  netIncomePct?: number | undefined;
  runningSplitTotal?: number | undefined;
  runningAdditionalChargeTotal?: number | undefined;
}
export interface ITransactionInfoModel {
  id?: number;
  date?: dayjs.Dayjs;
  createdOn?: dayjs.Dayjs;
  isUnderContract?: boolean;
  typeId?: number;
  yearId?: number;
  sourceId?: number | undefined;
  reasonId?: number | undefined;
  areaId?: number | undefined;
  coAgentId?: number | undefined;
  coAgent2Id?: number | undefined;
  address?: IAddressModel | undefined;
  notes?: string | undefined;
  price?: number;
  specialGroups?: number[] | undefined;
  specialTags?: number[] | undefined;
  clients?: ILookupItemSimpleModel[] | undefined;
  soiReferrers?: ILookupItemSimpleModel[] | undefined;
  agentReferrers?: ILookupItemSimpleModel[] | undefined;
  vendorReferrers?: ILookupItemSimpleModel[] | undefined;
  vendors?: ILookupItemSimpleModel[] | undefined;
  agentsReferred?: ILookupItemSimpleModel[] | undefined;
  createdByEmail?: string;
  referralOutTypeId?: number | undefined;
  financials?: IFinancialInfoModel | undefined;
}

export interface IPrefillDataModel {
  flatCommission?: number;
  brokerageAnniversaryDate?: dayjs.Dayjs;
  totalBrokerageAdditionalCharge?: number;
  brokerageAdditionalChargePct?: number;
  totalBrokerageSplit?: number;
  brokerageSplitPct?: number;
  brokerageFlatFees?: number;
}
export interface ICategoryDataSummaryModel {
  id?: string;
  key?: string;
  variableId?: number;
  totalCount?: number;
  totalAmount?: number;
  // Seller & Buyer only totals, used for Average Price
  sbCount?: number;
  sbAmount?: number;
  quarter?: number;
  month?: number;
  yearId?: number;
  /** Calendar year of the transaction date (a Pipeline entry's Potential Closing Date year) */
  year?: number;
  /** Lead/Active entry from the Pipeline folder */
  isPipeline?: boolean;
  /** Transaction whose Closing Date is after today */
  isUnderContract?: boolean;
  name?: string;
  color?: string;
}

export interface ISettlementDataModel {
  id?: string;
  transactionTypeId?: number | undefined;
  propertyAddress?: string | undefined;
  settlementDate?: dayjs.Dayjs | undefined;
  buyers?: string[] | undefined;
  sellers?: string[] | undefined;
  price?: number | undefined;
  clients?: string[];
}
export interface IExtractSettlementDataModel {
  data?: ISettlementDataModel[];
  errors?: string[];
}

export interface IAggregateDataSummaryModel {
  totalCount?: number;
  totalAmount?: number;
  yearId?: number | undefined;
  month?: number | undefined;
  quarter?: number | undefined;
}

export enum AggregationTypesEnum {
  Total = 0,
  Average = 1,
}

export interface IFormCategoryModel {
  id?: number;
  name?: string;
  internalName?: string;
}
export enum DropDownCategoryEnumModel {
  Reason = 0,
  TransactionType = 1,
  Source = 2,
  Clients = 3,
  Area = 4,
  SpecialGroup = 5,
  SpecialTag = 6,
  CoAgent = 7,
  SoiReferrer = 8,
  AgentReferrer = 9,
  VendorReferrer = 10,
  AgentReferred = 11,
  ReferralOutType = 12,
  Vendor = 14,
}

export interface IPagedResultOfLookupItemModel {
  result?: ILookupItemModel[];
  totalCount?: number;
}
export interface ILookupItemSimpleModel {
  id?: number;
  name?: string;
}

export enum ReferrerTypeEnumModel {
  Agent = 0,
  Soi = 1,
  Vendor = 2,
  ReferredOut = 3,
}
export enum TransactionRepeatEnumModel {
  Client = 0,
  Vendor = 1,
  Agent = 2,
  Soi = 3,
}

export interface IEntityRepeatModel {
  id?: number;
  name?: string;
  count?: number;
  totalVolume?: number;
  totalGci?: number | undefined;
  repeatCount?: number;
  referralCount?: number;
}

export interface DuplicateCandidateModel {
  duplicateCandidateId: number;
  sourceEntityType: string;
  sourceEntityId: number;
  sourceEntityName: string;
  duplicateEntityId: number;
  duplicateEntityName: string;
  detectedDate: string;
  matchReason: string;
  similarityScore: number;
}

export enum DuplicateActionEnumModel {
  Overwrite = 0,
  Skip = 1,
  AddAsNew = 2,
}

export enum LinkFieldEnumModel {
  CommissionPct = 1,
  BrokerageSplit = 2,
  AdditionalCharges = 3,
  BrokerageFlatFees = 4,
  FlatCommissionFee = 5,
  ReferralOutFeeReceived = 6,
  ReferralFeePaid = 7,
}

export enum FinancialCategoryEnumModel {
  Commission = 0,
  Gci = 1,
  EffectiveGci = 2,
  BrokerageTotal = 3,
  NetCommissionIncome = 4,
  NetIncome = 5,
  NetIncomePercent = 6,
}

export interface IBrokerageAnniversaryModel {
  brokerageAnniversaryId?: number;
  userId?: string;
  name?: string;
  anniversaryDate?: dayjs.Dayjs;
  commissionPercentage?: number;
  flatCommissionFee?: number;
  brokerageSplit?: number;
  splitCap?: number | undefined;
  additionalChargePercentage?: number;
  additionalChargeCap?: number | undefined;
  flatTransactionalFees?: number;
  referralOutFeeReceived?: number | undefined;
  rentalCommissionPercentage?: number | undefined;
  createdOn?: dayjs.Dayjs;
  createdBy?: string;
  updatedOn?: dayjs.Dayjs | undefined;
  updatedBy?: string | undefined;
  referralFeePaid?: number | undefined;
}

export interface IPagedResultOfTransactionInfo {
  result?: ITransactionInfoModel[];
  totalCount?: number;
}

export interface ITransactionYearModel {
  year?: number;
  transactionCount?: number;
  id?: number;
}

export interface ICreatedEntityModel {
  specialTags?: ILookupItemSimpleModel[] | undefined;
  specialGroups?: ILookupItemSimpleModel[] | undefined;
  coAgents?: ILookupItemSimpleModel[] | undefined;
  area?: ILookupItemSimpleModel | undefined;
  reasons?: ILookupItemSimpleModel[] | undefined;
  sources?: ILookupItemSimpleModel[] | undefined;
}

export interface ITransactionSearchModel {
  id?: number;
  /** TransactionStatus: 1 = Lead, 2 = Active, 3 = Transaction */
  status?: number;
  leadReceivedDate?: dayjs.Dayjs;
  date?: dayjs.Dayjs;
  createdOn?: dayjs.Dayjs;
  isUnderContract?: boolean;
  typeId?: number;
  yearId?: number;
  sourceId?: number | undefined;
  reasonId?: number | undefined;
  areaId?: number | undefined;
  coAgentId?: number | undefined;
  notes?: string | undefined;
  price?: number;
  grossCommIncomeAmt?: number;
  netIncome?: number;
  createdByEmail?: string | undefined;
  clientNames?: string | undefined;
  formattedAddress?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  street?: string | undefined;
  zip?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  county?: string | undefined;
}

// Business Planning Types
export type BusinessPlanningCategoryType =
  | "type"
  | "source"
  | "reason"
  | "zipCode"
  | "county"
  | "customArea";

export interface IBusinessPlanningCategoryItem {
  id?: string;
  name?: string;
  totalGci?: number;
  totalEffectiveGci?: number;
  totalCount?: number;
  totalPrice?: number;
  avgPrice?: number;
  avgCommissionPct?: number; // Calculated client-side
  gciPercentage?: number; // Calculated client-side
  isSb?: boolean;
  // id: number | string;
  // name: string;
  // totalGci: number;
  // totalEffectiveGci: number;
  // totalCount: number;
  // totalPrice: number;
  // avgPrice: number;
  // avgCommissionPct: number;
  // gciPercentage?: number; // Calculated client-side
}

export interface IBusinessPlanningCategoryData {
  category?: string;
  items?: IBusinessPlanningCategoryItem[];
  totalGci?: number;
  totalEffectiveGci?: number;
  totalCount?: number;

  // category: BusinessPlanningCategoryType;
  // items: IBusinessPlanningCategoryItem[];
  // totalGci: number;
  // totalEffectiveGci: number;
  // totalCount: number;
}

export interface IBusinessPlanningMonthlyTrend {
  month?: number;
  cumulativeGci?: number;
  yearId?: number;
}

export interface IBusinessPlanningYtdData {
  category?: string;
  items?: {
    id?: string;
    name?: string;
    transactionCount?: number;
  }[];
}

export interface IBusinessPlanningDataModel {
  evaluationYears?: number[];
  forecastYear?: number;
  categories?: IBusinessPlanningCategoryData[];
  monthlyTrend?: IBusinessPlanningMonthlyTrend[];
  currentYearMonthlyTrend?: IBusinessPlanningMonthlyTrend[] | undefined;
  ytdData?: IBusinessPlanningYtdData[] | undefined;
  underContractGci?: number;
  underContractLastMonth?: number;
  currentGciWithUnderContract?: number;
  /** GCI of Lead/Active entries with a Potential Closing Date this year or already passed */
  pipelineGci?: number;
  pipelineLastMonth?: number;
  /** Current GCI + under contract + pipeline ("+ Pipeline" dot) */
  currentGciWithUnderContractAndPipeline?: number;
}

export interface ILeadToClosedBucket {
  /** Whole months between Lead Received Date and Closing Date (0 = under half a month) */
  months: number;
  count: number;
  volume: number;
}

export interface ILeadToClosedResponse {
  buckets: ILeadToClosedBucket[];
  /** Transactions in the selection without a Lead Received Date */
  excludedCount: number;
}

export interface IBusinessPlanningRequest {
  yearIds: number[];
  forecastYear: "thisYear" | "nextYear";
  categories: BusinessPlanningCategoryType[];
}

export interface IBusinessPlanningProjection {
  id?: number | string;
  name?: string;
  gciPercentage?: number;
  avgPrice?: number;
  avgCommissionPct?: number;
  transactionsNeeded?: number;
  transactionsCompleted?: number;
}

export interface IBusinessPlanningCategoryProjection {
  category?: BusinessPlanningCategoryType | string;
  projections?: IBusinessPlanningProjection[];
}

export interface IGciTrackerSettings {
  gciTrackerSettingsId?: number;
  userId?: string;
  targetAnnualIncome?: number;
  evaluationYears?: number[];
  createdAt?: dayjs.Dayjs;
  updatedAt?: dayjs.Dayjs | undefined;
}

// Business Zones Types
export interface IBusinessZoneVariable {
  id?: string;
  name?: string;
  units?: number;
  unitsPercent?: number;
  volume?: number;
  volumePercent?: number;
  netIncome?: number;
  netIncomePercent?: number;
}

export interface IBusinessZoneCategoryData {
  category?: string;
  variables?: IBusinessZoneVariable[];
}

export interface IBusinessZoneData {
  zone?: string;
  categories?: IBusinessZoneCategoryData[];
}

export interface IBusinessZonesResponse {
  evaluationYears?: number[];
  greenThreshold?: number;
  yellowThreshold?: number;
  greenZone?: IBusinessZoneData;
  yellowZone?: IBusinessZoneData;
  redZone?: IBusinessZoneData;
}

export interface IBusinessZonesRequest {
  yearIds?: number[];
  greenThreshold?: number;
  yellowThreshold?: number;
}

export interface IBusinessZonesSettings {
  greenThreshold: number;
  yellowThreshold: number;
  evaluationYears: string; // Comma-separated year IDs
  zoneMetric: string; // "units", "volume", or "netIncome"
}
